import { useEffect } from "react";
import L from "leaflet";

export default function ConsolMapMessage({ message, map }) {
  useEffect(() => {
    if (map && message) {
      const msgControl = L.control({ position: "topright" });

      msgControl.onAdd = () => {
        var msgDiv = L.DomUtil.create("div", "mapSummaryMessage");
        msgDiv.innerHTML = message;
        return msgDiv;
      };

      msgControl.addTo(map);
    }
  }, [map, message]);

  return null;
}